import useUiContext from '@context/ui/useUiContext';
import { memo, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import UserDropdown from '@app/layouts/UserDropdown';
import SimpleBar from 'simplebar-react';
import BottomAvatar from './BottomAvatar';
import RecursiveMenu from './RecursiveMenu';
import { SidebarLogo } from './SidebarLogo';
type IconComponent = React.ComponentType<React.SVGProps<SVGSVGElement>>;
type MenuItem = {
  key: number;
  icon?: { filled: IconComponent; outline: IconComponent }; // <-- CHANGED  label: string | React.ReactElement;
  label: string;
  children: MenuItem[];
};

type Props = {
  collapseIcon?: React.ReactElement;
  menuItems?: MenuItem[];
};

const Sidebar = ({ menuItems = [] }: Props) => {
  const { isSidebarCollapsed } = useUiContext();
  const { t } = useTranslation();
  const [filteredItems, setFilteredItems] = useState<MenuItem[]>(menuItems);

  useEffect(() => {
    setFilteredItems(menuItems);
  }, [menuItems]);

  return (
    <div
      className={`sentry-unmask h-full flex flex-col relative rounded-2xl overflow-hidden ${
        isSidebarCollapsed ? 'w-16' : 'w-80'
      } transition-all duration-300 ease-in-out bg-app-primary-600`}
    >
      {/* Top: Logo + Collapse Button + Search */}
      <div className="flex flex-col gap-4 px-2 pt-4 pb-3">
        <div className={`flex ${isSidebarCollapsed ? 'flex-col-reverse' : 'flex-row'} justify-between items-center`}>
          <SidebarLogo collapsed={isSidebarCollapsed} />
        </div>
      </div>

      <div className="flex-1 min-h-0">
        <SimpleBar autoHide={false} forceVisible={true} className="w-full h-full pt-0">
          <div className={'flex-1 ' + (isSidebarCollapsed ? '' : 'pl-8')}>
            {filteredItems.length > 0 ? (
              <RecursiveMenu items={filteredItems} depth={0} />
            ) : (
              <div className="text-center text-gray-400 mt-4">{t('common-no-results')}</div>
            )}
          </div>
        </SimpleBar>
      </div>
      {/* Bottom: User Info */}
      <div className={`sentry-mask bg-app-gray-light w-full text-white/70 ${isSidebarCollapsed ? 'w-16 p-2' : 'w-64'}`}>
        {isSidebarCollapsed ? (
          <div className="flex justify-center">
            <UserDropdown />
          </div>
        ) : (
          <BottomAvatar />
        )}
      </div>
    </div>
  );
};

export default memo(Sidebar);
